import { Action, IOWidget, mk_widget, mk_pair } from 'widgets-for-react'
import React from 'react'

import { CMSState } from '../../../../cms/blocks/types.gen'
import { getClassName } from '../../../../cms/blocks/utils.gen'
import { PublicSite_CustomPageData } from '../../../application.mod'
import { Form } from '../../../../form'
import { FormState } from '../../../../form/types'
import { PublicSiteState } from '../../../../public_site.main.mod'
import { getRandomInt } from '../../../../../helpers'

export type FormBlockProps = {
  block_index: number
  form_id: string
  state: FormState
}

export type FormBlockStyle = Partial<{
  block_classname: string
  inner_classname: string
  content_classname: string
}>

export function FormBlock<CustomBlockData, extra_images>(
  props: FormBlockProps,
  options?: { style?: FormBlockStyle; key?: string }
): (s: CMSState<CustomBlockData, extra_images, PublicSite_CustomPageData>) => IOWidget<PublicSiteState, Action<CMSState<CustomBlockData, extra_images, PublicSite_CustomPageData>>> {
  return (s: CMSState<CustomBlockData, extra_images, PublicSite_CustomPageData>) => (public_state: PublicSiteState) =>
    mk_widget({
      run: set_state => (
        <section
          className={getClassName(options, 'block_classname', '')}
          key={options && options.key ? options.key : `iframe-block-${props.form_id}`}
        >
          <div className={getClassName(options, 'inner_classname', '')}>
            <div className={getClassName(options, 'content_classname', '')}>
              {
                Form(props.state).run(future_state => {
                  let new_state = future_state(props.state)
                  set_state(s => {

                    let currentBlock = s.blocks.get(props.block_index) as any
                    if (currentBlock.kind === 'formBlock') {
                      currentBlock = {
                        ...currentBlock,
                        value: mk_pair(
                          { ...currentBlock.value.fst, state: { ...new_state, route_state: "none" } },
                          currentBlock.value.snd
                        )
                      }
                    }


                    return { ...s, blocks: s.blocks.set(props.block_index, currentBlock) }
                  })
                })
              }
            </div>
          </div>
        </section>
      )
    })
}



// WEBPACK FOOTER //
// ./Client/components/public_site/blocks/custom_blocks/widgets/formBlock.mod.tsx